<template>
  <div class="as-popup" :class="[popupClass, { 'as-popup__show': isShowPopup }]">
    <div :class="'as-popup__wrap ' + wrapClass">
      <div class="as-popup__inner">
        <div v-if="isShowHeader" class="as-popup__header">
          <h3>{{ title }}</h3>
          <button @click="toggle" class="as-popup__close">&nbsp;</button>
        </div>
        <div class="as-popup__body">
          <slot name="content" />
        </div>
      </div>
    </div>
    <div @click="toggle" class="as-popup__mask-overlay"></div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue';

const emits = defineEmits(["toggle"]);

interface IProps {
  title: String;
  wrapClass?: String;
  isShowPopup: Boolean;
  popupClass?: String;
  isShowHeader?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isShowHeader: true
});

onMounted(() => {
  if(props.isShowPopup) {
    document.documentElement.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
  }
});

onUnmounted(() => {
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('overflow');
});

watch(() => props.isShowPopup, (newValue, _) => {
  if(newValue) {
    document.documentElement.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
  } else {
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }
});

const toggle = () => {
  emits("toggle");
};
</script>

<script lang="ts">
export default {};
</script>
